<div class="modal-header">
        <h4 class="modal-title fw-bold">
            <span jhiTranslate="site-admin.user.modal.role.title"></span>
        </h4>
        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-hidden="true"
                (click)="back()">
        </button>
</div>
<div class="modal-body">
    <form class="form-horizontal" #userRoleForm="ngForm">
        <div class="mb-3">
            <div class="col-sm-12">
                <span class="mandatory-asterisk"></span><span jhiTranslate="site-admin.user.modal.role.mandatory.fields"></span>
            </div>
        </div>
        <div class="mb-3 row required">
            <div class="col-md-3">
                <label for="roleTypeSelected" class="col-form-label fw-bold float-end" jhiTranslate="site-admin.user.modal.role.type"></label>
            </div>
            <div class="col-sm-7">
                <select class="form-select" [(ngModel)]="roleTypeSelected" #roleTypeInput="ngModel" required name="roleTypeSelected" id="roleTypeSelected"
                        (ngModelChange)="changeRole()">
					<option value=""><span jhiTranslate="site-admin.role.modal.dropdown.role.type"></span></option>
                    <option *ngFor="let roleType of roleTypes" [ngValue]="roleType.id">{{'site-admin.role.type.' + roleType.name.toLocaleLowerCase() | translate}}</option>
                </select>
            </div>
        </div>
        <div class="mb-3 row required">
            <div class="col-md-3">
                <label for="roleSelected" class="col-form-label fw-bold float-end" jhiTranslate="site-admin.user.modal.role.name"></label>
            </div>
            <div class="col-sm-7">
                <ng-select name="roleSelected" id="roleSelected" width="100%"
                            bindLabel="text"
                            bindValue="id"
                            [items]="roleOptions"
                            [(ngModel)]="roleSelected"
                            placeholder="{{'site-admin.user.modal.role.select' | translate}}"
                            data-test="roleDropdown"
                            [clearable]="true"
                            [disabled]="isRoleNameComboDisable()">
                </ng-select>
            </div>
        </div>
        <div class="row mb-3 required">
            <div class="col-md-3">
                <label class="col-form-label fw-bold float-end" jhiTranslate="site-admin.user.modal.role.crop"></label>
            </div>
            <div class="col-md-7">
                <ng-select  name="cropSelected" id="cropCombo" width="100%"
                            bindLabel="text"
                            bindValue="id"
                            [items]="cropOptions | CropDropDownData"
                            [(ngModel)]="cropSelected"
                            placeholder="{{'site-admin.user.modal.crop.select' | translate}}"
                            data-test="cropDropdown"
                            [clearable]="true"
                            [disabled]="isCropComboDisable()"
                            (ngModelChange)="changeCrop()">
                </ng-select>
            </div>
        </div>
        <div class="row mb-3 required">
            <div class="col-md-3">
                <label class="col-form-label fw-bold float-end" jhiTranslate="site-admin.user.modal.role.program"></label>
            </div>
            <div class="col-md-7">
                <ng-select name="programSelected" id="programCombo" width="100%"
                            bindValue="id"
                            bindLabel="text"
                            [items]="programOptions"
                            [(ngModel)]="programSelected"
                            placeholder="{{'site-admin.user.modal.program.select' | translate}}"
                            data-test="programDropdown"
                            [clearable]="true"
                            [disabled]="isProgramComboDisable()">
                </ng-select>
            </div>
        </div>
    </form>
</div>
<div class="modal-footer">
    <button type="button" class="btn btn-secondary" data-bs-dismiss="modal" (click)="back()">
        <span jhiTranslate="back"></span>
    </button>
    <button type="button" class="btn btn-primary" (click)="assignRole()" [disabled]="isAssignRoleButtonDisable()" aria-hidden="true" jhiTranslate="site-admin.user.modal.role.assign">
    </button>
</div>
